import React from "react";

class HeaderTabs extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="headerTabsContainer">
                <ul>
                    {this.props.menus.map(m => {
                        const handleClick = () => {
                            this.props.handleUpdateTabs(m);
                        }

                        return (
                            <li>
                                <a onClick={handleClick} class={`${this.props.activeMenu.id === m.id ? "active" : ""}`}>{m.label}</a>
                            </li>
                        )
                    })}
                </ul>
            </div>
        );
    }
}

export default HeaderTabs;